/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Achievements_Title1Inputs */

const id_offerdetail_achievements_title1 = /** @type {(inputs: Offerdetail_Achievements_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pencapaian`)
};

const ms_offerdetail_achievements_title1 = /** @type {(inputs: Offerdetail_Achievements_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pencapaian`)
};

const da_offerdetail_achievements_title1 = /** @type {(inputs: Offerdetail_Achievements_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Achievements`)
};

const de_offerdetail_achievements_title1 = /** @type {(inputs: Offerdetail_Achievements_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errungenschaften`)
};

const en_us2_offerdetail_achievements_title1 = /** @type {(inputs: Offerdetail_Achievements_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Achievements`)
};

const es_es2_offerdetail_achievements_title1 = /** @type {(inputs: Offerdetail_Achievements_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logros`)
};

const es_mx2_offerdetail_achievements_title1 = /** @type {(inputs: Offerdetail_Achievements_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logros`)
};

const fil_offerdetail_achievements_title1 = /** @type {(inputs: Offerdetail_Achievements_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Achievement`)
};

const fr_offerdetail_achievements_title1 = /** @type {(inputs: Offerdetail_Achievements_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Succès`)
};

const it_offerdetail_achievements_title1 = /** @type {(inputs: Offerdetail_Achievements_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risultati`)
};

const hu_offerdetail_achievements_title1 = /** @type {(inputs: Offerdetail_Achievements_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teljesítmények`)
};

const nl_offerdetail_achievements_title1 = /** @type {(inputs: Offerdetail_Achievements_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prestaties`)
};

const no_offerdetail_achievements_title1 = /** @type {(inputs: Offerdetail_Achievements_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prestasjoner`)
};

const pl_offerdetail_achievements_title1 = /** @type {(inputs: Offerdetail_Achievements_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Osiągnięcia`)
};

const pt_br2_offerdetail_achievements_title1 = /** @type {(inputs: Offerdetail_Achievements_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conquistas`)
};

const pt_offerdetail_achievements_title1 = /** @type {(inputs: Offerdetail_Achievements_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conquistas`)
};

const ro_offerdetail_achievements_title1 = /** @type {(inputs: Offerdetail_Achievements_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Realizări`)
};

const fi_offerdetail_achievements_title1 = /** @type {(inputs: Offerdetail_Achievements_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saavutukset`)
};

const sv_offerdetail_achievements_title1 = /** @type {(inputs: Offerdetail_Achievements_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prestationer`)
};

const vi_offerdetail_achievements_title1 = /** @type {(inputs: Offerdetail_Achievements_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thành tích`)
};

const tr_offerdetail_achievements_title1 = /** @type {(inputs: Offerdetail_Achievements_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başarımlar`)
};

const cs_offerdetail_achievements_title1 = /** @type {(inputs: Offerdetail_Achievements_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Úspěchy`)
};

const bg_offerdetail_achievements_title1 = /** @type {(inputs: Offerdetail_Achievements_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Постижения`)
};

const ru_offerdetail_achievements_title1 = /** @type {(inputs: Offerdetail_Achievements_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Достижения`)
};

const uk_offerdetail_achievements_title1 = /** @type {(inputs: Offerdetail_Achievements_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Досягнення`)
};

const ar_offerdetail_achievements_title1 = /** @type {(inputs: Offerdetail_Achievements_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الإنجازات`)
};

const hi_offerdetail_achievements_title1 = /** @type {(inputs: Offerdetail_Achievements_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपलब्धियाँ`)
};

const th_offerdetail_achievements_title1 = /** @type {(inputs: Offerdetail_Achievements_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ความสำเร็จ`)
};

const ja_offerdetail_achievements_title1 = /** @type {(inputs: Offerdetail_Achievements_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`実績`)
};

const zh_cn2_offerdetail_achievements_title1 = /** @type {(inputs: Offerdetail_Achievements_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`成就`)
};

const zh_hant1_offerdetail_achievements_title1 = /** @type {(inputs: Offerdetail_Achievements_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`成就`)
};

const ko_offerdetail_achievements_title1 = /** @type {(inputs: Offerdetail_Achievements_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`도전 과제`)
};

/**
* | output |
* | --- |
* | "Achievements" |
*
* @param {Offerdetail_Achievements_Title1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_achievements_title1 = /** @type {((inputs?: Offerdetail_Achievements_Title1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Achievements_Title1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_achievements_title1(inputs)
	if (locale === "ms") return ms_offerdetail_achievements_title1(inputs)
	if (locale === "da") return da_offerdetail_achievements_title1(inputs)
	if (locale === "de") return de_offerdetail_achievements_title1(inputs)
	if (locale === "en-US") return en_us2_offerdetail_achievements_title1(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_achievements_title1(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_achievements_title1(inputs)
	if (locale === "fil") return fil_offerdetail_achievements_title1(inputs)
	if (locale === "fr") return fr_offerdetail_achievements_title1(inputs)
	if (locale === "it") return it_offerdetail_achievements_title1(inputs)
	if (locale === "hu") return hu_offerdetail_achievements_title1(inputs)
	if (locale === "nl") return nl_offerdetail_achievements_title1(inputs)
	if (locale === "no") return no_offerdetail_achievements_title1(inputs)
	if (locale === "pl") return pl_offerdetail_achievements_title1(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_achievements_title1(inputs)
	if (locale === "pt") return pt_offerdetail_achievements_title1(inputs)
	if (locale === "ro") return ro_offerdetail_achievements_title1(inputs)
	if (locale === "fi") return fi_offerdetail_achievements_title1(inputs)
	if (locale === "sv") return sv_offerdetail_achievements_title1(inputs)
	if (locale === "vi") return vi_offerdetail_achievements_title1(inputs)
	if (locale === "tr") return tr_offerdetail_achievements_title1(inputs)
	if (locale === "cs") return cs_offerdetail_achievements_title1(inputs)
	if (locale === "bg") return bg_offerdetail_achievements_title1(inputs)
	if (locale === "ru") return ru_offerdetail_achievements_title1(inputs)
	if (locale === "uk") return uk_offerdetail_achievements_title1(inputs)
	if (locale === "ar") return ar_offerdetail_achievements_title1(inputs)
	if (locale === "hi") return hi_offerdetail_achievements_title1(inputs)
	if (locale === "th") return th_offerdetail_achievements_title1(inputs)
	if (locale === "ja") return ja_offerdetail_achievements_title1(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_achievements_title1(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_achievements_title1(inputs)
	return ko_offerdetail_achievements_title1(inputs)
});
export { offerdetail_achievements_title1 as "offerDetail.achievements.title" }